import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const USAPage = () => {
  return <DestinationTemplate destinationId="usa" />;
};

export default USAPage;
